import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import axios from 'axios'

import VueLazyload from 'vue-lazyload'
import Msg from 'vue-message'
import store from './store'
import 'vant/lib/index.css';
import Vant from 'vant';
// import { Picker, DatetimePicker, Popup, Dialog, Circle, Swipe, SwipeItem, DropdownMenu, DropdownItem, Calendar, Tab, Tabs, RadioGroup, Radio } from 'vant';

// import VeRing from 'v-charts/lib/ring.common'
// import VeHistogram from 'v-charts/lib/histogram.common'
// import VeLine from 'v-charts/lib/line.common'
// import VeRadar from 'v-charts/lib/radar.common'
// import VePie from 'v-charts/lib/pie.common'
// import VeFunnel from 'v-charts/lib/funnel.common'

import ToastWin from '@/components/base/toast/toast'
import VToastWin from '@/components/base/vToast/toast'

import { isApp, isWX, isIOS } from '@/api/device.js'
import VConsole from 'vconsole'
import xss from 'xss'
Vue.prototype.$xss = xss

Vue.use(VueLazyload)
Vue.use(Msg)
Vue.use(Vant);
// Vue.use(Picker)
// Vue.use(DatetimePicker)
// Vue.use(Popup)
// Vue.use(Dialog)
// Vue.use(DropdownMenu)
// Vue.use(DropdownItem)
// Vue.use(Circle)
// Vue.use(Swipe)
// Vue.use(SwipeItem)
// Vue.use(Calendar)
// Vue.use(Tab);
// Vue.use(Tabs);
// Vue.use(Radio);
// Vue.use(RadioGroup);

// Vue.component(VeRing.name, VeRing)
// Vue.component(VeHistogram.name, VeHistogram)
// Vue.component(VeLine.name, VeLine)
// Vue.component(VeRadar.name, VeRadar)
// Vue.component(VePie.name, VePie)
// Vue.component(VeFunnel.name, VeFunnel)

Vue.prototype.$toast = ToastWin.install
Vue.prototype.$vToast = VToastWin.install

Vue.config.productionTip = false
if (process.env.NODE_ENV === 'development') {
  new VConsole()
} else {
  if (location.host.indexOf('test') > -1) {
    new VConsole()
  }
}

Vue.filter('plus', function (num1, num2) {
  return parseInt(num1) + parseInt(num2)
})
Vue.filter('toFixed', function (price, limit) {
  let _limit = limit || 2
  return price.toFixed(_limit)
})

Vue.filter('moneyMultiply', function (money, multi) {
  return parseFloat(money * multi).toFixed(2)
})
Vue.filter('moneyToW', function (num) {
  let resNum = Number(num)
  if (resNum === 0) {
    return '0W'
  } else {
    return `${Number(parseFloat(resNum / 10000).toFixed(4))}W`
  }
})
Vue.filter('moneyTow', function (num) {
  let resNum = Number(num)
  if (resNum === 0) {
    return '0W'
  } else {
    return `${Number(parseFloat(resNum / 10000).toFixed())}W`
  }
})
Vue.filter('transferDate', function (date) {
  let _date = date.replace('/Date(', '').replace(')/', '')
  let resDate = ''
  if (_date.indexOf('+') > 0) {
    resDate = _date.substring(0, _date.indexOf('+'))
  } else if (_date.indexOf('-') > 0) {
    resDate = _date.substring(0, _date.indexOf('-'))
  } else {
    resDate = _date
  }
  let newDate = new Date(parseInt(resDate, 10))
  let month = newDate.getMonth() + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1
  let currentDate = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate()
  let hours = newDate.getHours() < 10 ? '0' + newDate.getHours() : newDate.getHours()
  let minutes = newDate.getMinutes() < 10 ? '0' + newDate.getMinutes() : newDate.getMinutes()
  let second = newDate.getMilliseconds() / 1000 < 10 ? '0' + parseInt(newDate.getMilliseconds() / 1000) : parseInt(newDate.getMilliseconds() / 1000)
  return newDate.getFullYear() + '-' + month + '-' + currentDate + ' ' + hours + ':' + minutes + ':' + second
})

Vue.filter('numToMoney', function (num, decimal = 2, split = ',') {
  /*
    parameter：
    num：格式化目标数字
    decimal：保留几位小数，默认2位
    split：千分位分隔符，默认为,
    moneyFormat(123456789.87654321, 2, ',') // 123,456,789.88
  */
  function thousandFormat(num) {
    const len = num.length
    return len <= 3 ? num : thousandFormat(num.substr(0, len - 3)) + split + num.substr(len - 3, 3)
  }
  if (isFinite(num)) { // num是数字
    if (num === 0) { // 为0
      return num.toFixed(decimal)
    } else { // 非0
      var res = ''
      var dotIndex = String(num).indexOf('.')
      if (dotIndex === -1) { // 整数
        res = thousandFormat(String(num)) + '.' + '0'.repeat(decimal)
      } else {
        // 保留decimals位小数
        const numStr = String((Math.round(num * Math.pow(10, decimal)) / Math.pow(10, decimal)).toFixed(decimal)) // 四舍五入，然后固定保留2位小数
        const decimals = numStr.slice(dotIndex, dotIndex + decimal + 1) // 截取小数位
        res = thousandFormat(numStr.slice(0, dotIndex)) + decimals
      }
      return res
    }
  } else {
    return '--'
  }
})

Vue.directive('loadMore', {
  inserted: (el, bind, vnode) => {
    el.addEventListener('scroll', () => {
      if ((el.scrollHeight - el.clientHeight) <= (el.scrollTop + 10)) {
        bind.value()
      }
    })
  }
})

Vue.directive('blur', {
  inserted: (el, bind, vnode) => {
    el.addEventListener('blur', () => {
      var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i)
      var wechatVersion = wechatInfo && wechatInfo[1]
      var u = navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIOS() && (isApp() || isWX())) {
        var currentPosition, timer
        var speed = 1
        timer = setInterval(function () {
          currentPosition = document.documentElement.scrollTop || document.body.scrollTop
          currentPosition -= speed;
          window.scrollTo(0, currentPosition)
          currentPosition += speed
          window.scrollTo(0, currentPosition)
          clearInterval(timer)
        }, 1)
      }
    })
  }
})
Vue.prototype.$axios = axios
Vue.prototype.getConfigJson = function () {
  if (process.env.NODE_ENV !== 'development') {
    this.$axios.get("serverconfig.json").then((result) => {
      localStorage.setItem('apiUrl', result.data.ApiUrl)
    }).catch((error) => {
      console.log(error)
    })
  }
}
/* eslint-disable no-new */
let newVue = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
